/**
 * Generic, customer-facing names for each {@link ShippingOptionKind}. Used as a
 * fallback/label in the merchant panel and emails. A concrete option may override
 * the displayed name via {@link ShippingOption.label}.
 */
export const shippingOptionKindNames = new Map([
    ["inpost-paczkomat", "Dostawa do paczkomatu InPost"],
    ["address", "Dostawa pod adres"],
    ["custom", "Inna metoda dostawy"],
]);
/**
 * Resolves the flat numeric price of a shipping option. The merchant UI only emits a
 * number or a `constant` provider; richer providers should be resolved server-side with
 * `provideValue` instead.
 */
export const resolveShippingOptionPrice = (price) => {
    if (typeof price === "number")
        return price;
    if (price.type === "constant")
        return Number(price.value);
    return 0;
};
export const createDefaultShippingOption = (kind) => {
    var _a;
    return ({
        id: crypto.randomUUID(),
        kind,
        label: (_a = shippingOptionKindNames.get(kind)) !== null && _a !== void 0 ? _a : "",
        price: { type: "constant", value: 0 },
        enabled: true,
    });
};
/**
 * Default shipping configuration: disabled, pre-seeded with the two standard
 * options so a merchant only has to enable and price them.
 */
export const defaultGalleryShipping = () => ({
    enabled: false,
    options: [
        createDefaultShippingOption("inpost-paczkomat"),
        createDefaultShippingOption("address"),
    ],
});
